<template>
    <div>
        <transition-group
            v-if="loading && !items.length"
            mode="out-in"
            name="lb-project-list"
            tag="div"
            class="columns is-multiline is-mobile mx-0"
            appear
        >
            <div
                v-for="i in 20"
                :key="i"
                class="
                    column
                    is-12-mobile is-6-tablet is-4-desktop is-3-widescreen
                "
            >
                <div class="lb-project-box is-loading"></div>
            </div>
        </transition-group>
        <section v-else>
            <projects-grid
                ref="gridProjects"
                :projects="items"
                :showCreationCard="canSowCreationCard"
                @deleteProject="deleteProject"
            />
        </section>
    </div>
</template>

<script>
import ProjectsGrid from '@/components/ProjectsGrid';
import _ from 'underscore';
export default {
    components: {
        ProjectsGrid,
    },
    props: {
        items: { type: Array, default: () => [] },
        loading: {
            type: Boolean,
            default: true,
        },
        activeFilter: {
            type: String,
            default: '',
        },
    },
    data() {
        return {};
    },
    computed: {
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        canSowCreationCard() {
            // console.log(this.activeFilter);
            let canCreate = false;
            if (this.activeFilter == 'mine') {
                //return true;

                if (this.isAdmin) {
                    return true;
                }
                
                if (this.$store.getters.user.entities) {
                    // console.log("checking entities permissions")
                    this.$store.getters.user.entities.forEach(element => {
                        
                        if ((element.entity._id == this.$store.getters.user.school._id) && (element.permission != 'GUEST')) {
                            // console.log("no creation")
                            canCreate = true;
                        } /*else {
                            console.log("can create")
                            canCreate=true
                        }*/
                    });
                } 
            }
            return canCreate;
        },
    },
    methods: {
        deleteProject(projectId) {
            this.$emit('delete', projectId);
        },
        selectProject(project) {
            this.$refs.gridProjects.selectProject(project);
        },
    },
};
</script>

<style scoped>
router-link {
    cursor: pointer;
}
</style>
